/**
 * @file 开发者社区 活动日历
 * @author WanZhongYun(wanzhongyun@baidu.com)
 */
import React from 'react';
import { Button } from 'antd';
import { IActivityCalendar } from './../../types';

import './style.less';

const DeveloperEventCalendar: React.FC<IActivityCalendar> = props => {
    const {
        title,
        linkAllLink = '',
        list = []
    } = props;
    return (
        <div className="developer-event-calendar-wrapper">
            <div className="event-calendar-title">{title}</div>
            <div className="event-calendar-card-wrapper">
                {
                    list.map(item => <div className="event-calendar-card" key={item.title}>
                        <a href={item.link}><img className={`event-calendar-png`} src={item.imageUrl} alt="" /></a>
                        <div className="event-calendar-content-wrapper">
                            <a className="event-calendar-link" href={item.link}><p className="event-calendar-card-title">{item.title}</p></a>
                            <span className="event-calendar-time">{item.date}</span>
                            <a className="event-calendar-link" href={item.link}>{item.text}</a>
                        </div>
                    </div>)
                }
            </div>
            <div className="event-calendar-extend">
                <Button className="event-calendar-extend" type="link" onClick={() => {window.location.href = linkAllLink}}>{`查看全部 >`}</Button>
            </div>
        </div>
    );
};

export default DeveloperEventCalendar;